export const convertOptionsToNewFormat = (options = []) => {
  const finalOptions = options.map(option => {
    const { values, popular_values, ...otherProps } = option;
    const [{ option_values }] = values;

    const finalValues = option_values.map(optionValue => ({
        ...optionValue,
      }));
    return { ...otherProps, values: finalValues };
  });
  return finalOptions;
};

export const productHasOption = (
  options = [],
  optionValueIdToCheck = null,
  primaryOptionId = null
) => {
  if (!options?.length || !optionValueIdToCheck || !primaryOptionId) {
    return false;
  }

  const primaryOption = options.find(
    opt => parseInt(opt.id, 10) === parseInt(primaryOptionId, 10)
  );
  if (!primaryOption) {
    return false;
  }

  return primaryOption.values.some(
    optVal => parseInt(optVal.id, 10) === parseInt(optionValueIdToCheck, 10)
  );
};
